import {ThemeOptions} from '@mui/material';

const defaultTheme: ThemeOptions = {};
export default defaultTheme;
